module.exports = __webpack_public_path__ + "static/media/snorkel-hierro.dc8d252f.jpg";